import { generateClassName } from '@klv/shared/utils/functions';
import * as styles from './styles/twoColumnHeader.module.scss';
import type { ITwoColumnHeaderProps, TMediaAlignment } from '../types';

export const TwoColumnHeader = ({ eyebrow, headline, subhead, mediaAlignment }: ITwoColumnHeaderProps) => (
  <div className={generateClassName([styles.gridText, styles[mediaAlignment as TMediaAlignment]])}>
    {eyebrow && <div className={`eyebrow ${styles.eyebrow}`}>{eyebrow}</div>}
    {headline && <h2 className={`h3 semibold ${styles.headline}`}>{headline}</h2>}
    {subhead && <div className={`p2 ${styles.subtext}`} dangerouslySetInnerHTML={{ __html: subhead }} />}
  </div>
); 
